import { ShieldCheck, Umbrella, Home, Award } from "lucide-react";
import { Reveal } from "./Reveal";

const ADVANTAGES = [
    {
        icon: ShieldCheck,
        title: "Aucune avance de frais",
        text: "Vous ne payez rien, nous nous occupons de tout.",
    },
    {
        icon: Umbrella,
        title: "Toutes assurances",
        text: "Nous travaillons avec toutes les compagnies.",
    },
    {
        icon: Home,
        title: "Intervention à domicile",
        text: "Nous venons chez vous ou sur votre lieu de travail.",
    },
    {
        icon: Award,
        title: "Garantie à vie",
        text: "Sur la pose et l'étanchéité du pare-brise.",
    },
];

export const Advantages = () => (
    <section data-testid="advantages-section" className="relative z-20 bg-[#F7F5F1] pb-20">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <Reveal y={48}>
                <div className="-mt-28 bg-white rounded-2xl shadow-[0_30px_80px_rgba(10,14,23,0.35)] border border-black/5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 overflow-hidden divide-y sm:divide-y lg:divide-y-0 lg:divide-x divide-black/[0.06]">
                    {ADVANTAGES.map((adv, i) => (
                        <div
                            key={adv.title}
                            data-testid={`advantage-${i}`}
                            className="group p-8 sm:p-9 transition-colors duration-500 hover:bg-[#FBF7EE]"
                        >
                            <span className="inline-flex items-center justify-center w-14 h-14 rounded-full border-2 border-midnight-800 text-midnight-800 transition-[transform,border-color,color] duration-500 group-hover:scale-110 group-hover:border-gold-dark group-hover:text-gold-dark">
                                <adv.icon size={26} strokeWidth={1.75} />
                            </span>
                            <h3 className="mt-6 font-display font-extrabold uppercase tracking-wide text-sm text-midnight-900 leading-snug">
                                {adv.title}
                            </h3>
                            <p className="mt-2 text-sm text-gray-500 leading-relaxed">{adv.text}</p>
                        </div>
                    ))}
                </div>
            </Reveal>
        </div>
    </section>
);
